import React from "react";
import classes from "./BasicInfo.module.css";

export default function BasicInfo() {
  return (
    <div>
      <div className={classes.fontStyle}>כתובתינו:</div>
      <div className={classes.fontStyle}>הסדנא 8 חולון, קומה 2, ביתן 4</div>
      <div className={classes.fontStyle}>חנייה חינם במקום</div>
      <div className={classes.fontStyle}>טלפון: 050-5582265</div>
    </div>
  );
}
